import React, {PureComponent} from "react"

import platformTracking from "@irati-tracking/platform"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {CheckoutRedemption} from "@irati/types"
import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import history from "@irati/utils/history"

import {RouteComponentProps} from "react-router-dom"
import {H1} from "@irati/ui/src/Typography"
import PropTypes from "prop-types"
import Tabs from "../styled/Tabs"
import PerksList from "./PerksList"

interface Props extends InjectIntl, WithAuth, RouteComponentProps<{redemptionStatus: string}> {
}

interface State {
  showRedemptionPopup: boolean,
  selectedRedemption?: CheckoutRedemption | null
}

class MyPerksList extends PureComponent<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  componentDidMount() {
    platformTracking.view("order_history")
  }

  render() {
    const {formatMessage, match} = this.props
    const isUsedPerks = match.params.redemptionStatus === "used"

    return (
      <>
        <H1 marginBottom={5} marginTop={6}>
          <FormattedMessage id="perks.components.accountMenu.accountMenu.myPerks" />
        </H1>
        <Tabs
          activeKey={isUsedPerks ? "used" : "new"}
          id="myPerksTabs"
          onSelect={(value) => {
            history.push(`/account/my-perks/${value}`, this.context)
          }}
          tabs={[
            {
              title: formatMessage({id: "perks.components.myPerks.myPerksList.new"}),
              key: "new",
              component: <PerksList />
            },
            {
              title: formatMessage({id: "perks.components.myPerks.myPerksList.used"}),
              key: "used",
              component: <PerksList isUsedPerks />
            }
          ]} />
      </>
    )
  }
}

export default injectIntl(withAuth(MyPerksList))
